goog.provide('el8.ptdata.model.letter');

goog.require('el8.data.currUser');
goog.require('el8.data.docTags');
goog.require('el8.data.referencedUsers');
goog.require('el8.model.base');
goog.require('el8.model.identify');
goog.require('el8.ptdata.comments');
goog.require('el8.ptdata.model.note.muInfo');
goog.require('el8.ptdata.model.order');
goog.require('el8.ptdata.model.letterAttachment');
goog.require('el8.ptdata.model.orderSet.referral');
goog.require('el8.template.ptdata.letters');
goog.require('el8.service.tz');
goog.require('el8.service.urls');
goog.require('el8.ptdata.model.noteItem');
goog.require('el8.ptdata.model.orderSet');
goog.require('el8.ptdata.model.orderSet.referral');


(function() {

    var _class = function(spec) {
        spec = spec || {};
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();
    _class.makeHoldable();
    _class.addDocTags();

    // the many kinds of recipients possible for a letter
    _class.addStringProperty('faxTo', true); // fax num
    _class.addStringProperty('emailTo'); // email - we don't allow an emailTo without a sendToContact
    _class.addStringProperty('directMessageTo'); // direct - we won't have an directMessageTo withuot a sendToContact (comes from the related letter)
    _class.addStringProperty('sendToName', true); // raw string
    _class.addIntProperty('sendToContactId', true); // a physician
    _class.addBoolean('sendToPatient', true, false); // for patient passport
    _class.addBoolean('referralLetter', false, false); // for referral letter
    _class.addIntProperty('sendToAccessUserId'); // this letter was sent via Elation / Access
    _class.addStringProperty('toNumber', false); // the actual fax number that was used
    _class.addStringProperty('letterType', true); // fax type: CONSULTANT_LETTER, PATIENT_LETTER, REFERRAL_LETTER
    // NOTE: below property is only being used for amplitude right now. Not passed from backend
    _class.addStringProperty('recipientType', true); // physicians's contact_type (e.g. physician or medical_group)

    // these two properties sort through all the kinds of recipients
    // and return a useful string representation / fax number if available
    _class.addStringProperty('displayTo');

    // delivery methods: emr, passport, fax, email, printed (for 'passport', need to also look at sendToPatient)
    _class.addStringProperty('deliveryMethod');
    _class.addBoolean('faxAttachments', true); // if this was faxed, did we include the attachments in the fax?

    _class.addBoolean('withArchive', true); // do we have a ZIP in addition to a single, big PDF?
    _class.addBoolean('processed'); // whether or not the ZIP/PDF for this letter has been built

    _class.addBoolean('withPlrInvite', false); // was this letter sent w/ an intention to invite someone to join care team?

    _class.addStringProperty('subject', true);
    _class.addStringProperty('body', true);
    _class.addDate('deliveryDate', true);
    _class.addDate('unreadAlertDate', true);
    _class.addIntProperty('unreadAlertInDays', true);

    _class.addDate('signedUnreadAlertDate', true);
    _class.addBoolean('unreadAlertDisabled', false);

    // do we have an active unread alert for this letter (active means we should notify the user of this unread letter)
    _class.addBoolean('unreadAlertActive', true);

    // list of unread notifications (unsigned and signed)
    _class.addProperty('signedUnreadNotifications', false, []);
    _class.addStringProperty('latestUnsignedUnreadNotification', false);

    _class.addStringProperty('directMessageStatus');
    _class.addDateTime('directMessageSentOn');

    _class.addStringProperty('faxStatus');
    _class.addStringProperty('faxErrorShortMessage');
    _class.addStringProperty('faxErrorLongMessage');
    _class.addProperty('showFaxErrorDetails', true);
    _class.addIntProperty('faxId', true);
    _class.addIntProperty('letterId', true);
    _class.addBoolean('failureUnacknowledged');
    _class.addDateTime('faxedAt');
    _class.addDateTime('faxCompleteTime');
    _class.addBoolean('commentsAllowed', false); // whether the comment section should be rendered

    _class.addIntProperty('printHeaderId', true);

    _class.addModelSetProperty('attachments', el8.ptdata.model.letterAttachment, true, []);

    // passport related fields
    _class.addProperty('commentIds', false, []);
    _class.addDateTime('patientReadTime');
    _class.addIntProperty('closeUserId');
    _class.addDateTime('closeTime');

    // email/access related fields
    _class.addDateTime('viewedAt');

    // used to track the expanded state of the chart render item, for feed item refresh
    _class.addBoolean('chartItemExpanded', false);

    // referral fields
    _class.addIntProperty('referralOrderId');

    // track meaningful use data
    _class.addModelProperty("meaningfulUseInfo", el8.ptdata.model.note.muInfo, true);

    // flag to tell backend print form to skip the cover page
    _class.addBoolean('skipCoverPage', true, false);

    _class.addStringProperty('inProgressComment', false);

    _class.prototype.populate = function(spec) {
        this.parent.populate.call(this, spec);
        // load these comments into the comment cache and store just the ids in the letter
        if (spec.comments) {
          el8.ptdata.comments.create(spec.comments, true);
          this.setCommentIds(_.pluck(spec.comments, 'id'));
        }
        // load the referral in the referral cache and store just the id in the letter
        if (spec.referral_order) {
          el8.ptdata.referralOrders.create(spec.referral_order, true);
          this.setReferralOrderId(spec.referral_order.id);
        }

        if (spec.doc_tags) {
            el8.data.docTags.create(spec.doc_tags, true);
            this.setDocTagIds(_.pluck(spec.doc_tags, 'id'));
         }
    };
    _class.prototype.getIcd9CodeObjs = function() {
        if (!this.getReferralOrder()) { return []; }
        return this.getReferralOrder().getIcd9CodeObjs();
    };
    _class.prototype.getIcd10CodeObjs = function() {
        if (!this.getReferralOrder()) { return []; }
        return this.getReferralOrder().getIcd10CodeObjs();
    };

    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.letters.noteSummary(this.asSoyMap()).el8_unescape();
    };
    _class.prototype.getDescription = function() {
        return 'Letter';
    };
    _class.prototype.isReferralLetter = function() {
        return this.getLetterType() === el8.util.consts.REFERRAL_LETTER;
    };
    _class.prototype.disableUnreadNotification = function() {
        this.setUnreadAlertDate(null);
        this.setUnreadAlertInDays(null);
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);

        delete mapped['signUserBehalfId'];
        mapped['signUserBehalfName'] = this.getSignUserBehalfName();

        delete mapped['signUserId'];
        mapped['signUserName'] = this.getSignUserName();
        mapped['signUserType'] = this.getSignUserType();

        delete mapped['closeUserId'];
        mapped['closeUserName'] = this.getCloseUserId() ?
            el8.data.referencedUsers.getById(this.getCloseUserId()).getFullName() : '';
        mapped['canReopenThread'] = this.getCloseUserId() ?
            (this.getCloseUserId() === el8.data.currUser.getId()) : false;

        delete mapped['commentIds'];
        mapped['comments'] = this.getComments().map(el8.model.toSoyMapFn);

        // can't compare dates in soy because they've already been turned to strings
        mapped['isPostDated'] = this.getDeliveryDate() && (this.getDeliveryDate() > el8.service.tz.now());

        if (this.getReferralOrder()) {
          delete mapped['referralOrderId'];
          mapped['referralOrder'] = this.getReferralOrder().asSoyMap();
        }

        delete mapped['docTagIds'];
        mapped['docTags'] = this.getDocTagMaps();

        return mapped;
    };

    _class.prototype.getReferralOrder = function() {
        if (!this.isReferralLetter()) {
            return null;
        }
        var referral = el8.ptdata.referralOrders.getById(this.getReferralOrderId());
        if (!referral) {
            referral = el8.ptdata.referralOrders.getDeletedById(this.getReferralOrderId());
            if (!this.isDeleted() && referral) { UIM && UIM.logError('Undeleted Referral Letter with deleted referral order: Letter id ' + this.getId()); }
        }
        return referral;
    };

    _class.prototype.asMap = function() {
        var result = this.parent.asMap.call(this, true, false);
        result['signed_off'] = this.isSignedOff();

        // for some reason, asMap() returns the soyMap of modelSetProperties, which means
        // camelCase instead of underscoring and incorrectly prefixed booleans
        result['attachments'] = this.getAttachments().map(function(a) { return a.asMap(true, false); });

        if (this.getReferralOrder()) {
            result['referral_order'] = this.getReferralOrder().asMap(true, false);
        }
        return result;
    };

    _class.prototype.getComments = function() {
        return this.getCommentIds().map(function(id) {
            return el8.ptdata.comments.getById(id);
        });
    };


    _class.prototype.getAttachmentPageCounts = function(successCb, errorCb) {
        if (!successCb) { return; } // this won't ever do anything visible...
        var attachments = this.getAttachments();
        if (!attachments.length) {
            successCb({total_pages: 0 });
            return;
        }
        var submissionDict = {'id[]': attachments.map(function(a) { return a.getAttachmentKey(); }) };

        $.el8_ajax({
            type: 'GET',
            data: submissionDict,
            url: el8.service.urls.get('letterPageCount', [this]),
            success: successCb,
            error: errorCb
        });
    };
    _class.prototype.getFinalPdfPages = function(opts) {
        if (!this.getSignDate()) { return; } // definitely won't work until signed

        var numPages;
        $.el8_ajax({
            type: 'GET',
            async: opts.async,
            url: el8.service.urls.get('letterPdfCountPages', [this]),
            success: function(data) {
                numPages = data;
                if (opts.successCb) { opts.successCb(data); }
            },
            error: opts.errorCb
        });

        if (opts.async === false) { return numPages; }
    };

    // Convenience method to make sure that setting a new recipient of one type
    // (e.g., fax num) clears any old recipients of another type (e.g., physicianId)
    _class.prototype.setRecipient = function(recipientField, value) {
        if (recipientField === 'faxTo') {
            this.setFaxTo(value);
            this.setSendToName('');
            this.setSendToContactId(null);
            this.setSendToPatient(false);
        } else if (recipientField === 'sendToName') {
            this.setSendToName(value);
            this.setFaxTo('');
            this.setSendToContactId(null);
            this.setSendToPatient(false);
        } else if (recipientField === 'sendToContactId') {
            this.setSendToContactId(value);
            this.setFaxTo('');
            this.setSendToName('');
            this.setSendToPatient(false);
        } else if (recipientField === 'sendToPatient') {
            this.setSendToPatient(value);
            this.setFaxTo('');
            this.setSendToContactId(null);
            this.setSendToName('');
        }
    };

    _class.prototype.deleteAttachment = function(attachmentKeyToDelete) {
        var newSet = _.reject(this.getAttachments(), function(a) { return a.getAttachmentKey() === attachmentKeyToDelete; });
        this.setAttachments(newSet);
    };

    _class.prototype.addComment = function(opts) {
        opts = opts || {};

        var submissionDict = {};
        if (opts.message) {
            submissionDict['new_comment'] = opts.message;
        }
        if (this.getCommentIds().length) {
            submissionDict['comments_signed_off'] = this.getCommentIds();
        }
        if (opts.closeThread === true) {
            submissionDict['close_thread'] = true;
        }
        if (opts.reopenThread === true) {
            submissionDict['reopen_thread'] = true;
        }

        var ajaxArgs = {
            type: 'POST',
            async: (opts.async !== false), // default true
            data: JSON.stringify(submissionDict),
            url: el8.service.urls.get('addLetterComment', [this]),
            success: function(data) {
                var updatedLetter = el8.ptdata.letters.create(data);
                if (opts.successCb) { opts.successCb(updatedLetter); }
            }
        };
        // want to support either error (default) or error_override (for dealing with closed threads)
        if (opts.errorOverrideCb) {
            ajaxArgs.error_override = opts.errorOverrideCb;
        } else {
            ajaxArgs.error = opts.errorCb;
        }
        $.el8_ajax(ajaxArgs);
    };
    _class.prototype.refaxLetter = function(opts) {
        opts = opts || {};

        var data = {};
        if (opts.dismissFailure) {
            data.dismiss_failure = true;
        }
        if (!el8.util.isNone(opts.faxAttachments)) {
            data.fax_attachments = opts.faxAttachments;
        }
        if (opts.unreadAlertInDays) {
            data.unread_alert_in_days = opts.unreadAlertInDays;
        }
        if (opts.signedUnreadAlertDate) {
            data.signed_unread_alert_date = opts.signedUnreadAlertDate;
        }
        if (opts.resendEmail) {
            data.resend_email = opts.resendEmail;
        }

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('refaxLetter', [this]),
            data: JSON.stringify(data),
            success: function(data) {
                var updatedLetter = el8.ptdata.letters.create(data);
                if (opts.successCb) { opts.successCb(updatedLetter); }
            },
            error: opts.errorCb
        });
    };

    _class.prototype.dismissComments = function(successCb, errorCb) {
        // without a message, addComment just dismisses existing comments
        this.addComment({successCb: successCb, errorCb: errorCb});
    };
    _class.prototype.dismissFailedFax = function(successCb, errorCb) {
        this.refaxLetter({
            dismissFailure: true,
            successCb: successCb,
            errorCb: errorCb
        });
    };

    _class.prototype.closeThread = function(successCb, errorCb) {
        // this is like dismissComments but we also close the thread
        this.addComment({
            closeThread: true,
            successCb: successCb,
            errorCb: errorCb
        });
    };
    _class.prototype.reopenThread = function(successCb, errorCb) {
        // this is like dismissComments but we also close the thread
        this.addComment({
            reopenThread: true,
            successCb: successCb,
            errorCb: errorCb
        });
    };

    _class.prototype.getNewCommentCount = function() {
        var commentIsUnread = function(c) { return !c.isRead(); };
        return _.filter(this.getComments(), commentIsUnread).length;
    };

    // ===================================
    // Meaningful use info related methods
    // ====================================
    el8.ptdata.model.note.addMuInfoMethods(_class);
    _class.prototype.updateMeaningfulUseInfo = function(_data) {
        var that = this;
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('documentMeaningfulUse', [this.getId()]),
            data: {data: JSON.stringify(_data)},
            success: function(resp) {
                that.setMeaningfulUseInfoFromSpec(resp);
            }
        });
    };

    el8.ptdata.model.letter = function(spec) {
        return new _class(spec);
    };

})();
